module.exports = __webpack_public_path__ + "6-halloween-snow.d40af34e0574b0df847a.png";


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/assets/images/festival/6-halloween-snow.png
// module id = ../../../../../src/assets/images/festival/6-halloween-snow.png
// module chunks = styles